import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=18c2fb08&scoped=true"
import script from "./ProgramCard.vue?vue&type=script&lang=js"
export * from "./ProgramCard.vue?vue&type=script&lang=js"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=18c2fb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2fb08",
  null
  
)

export default component.exports